export default "__VITE_ASSET__CqpL2dUb__"